import { SelectItem } from 'primeng/api';

export const similarOrderFilterOptions: SelectItem[] = [
  { label: 'Avec Ordres Similaires', value: 'WITH_DUPLICATES' },
  { label: 'Sans Ordres Similaires', value: 'WITHOUT_DUPLICATES' },
  { label: "Avec sélection d'ordres à clôturer", value: 'WITH_SELECTED' },
  { label: "Sans sélection d'ordres à clôturer", value: 'WITHOUT_SELECTED' },
];

export const priorityFilterOptions: SelectItem[] = [
  { label: 'Tous', value: null },
  { label: 'Priorité à revoir', value: 'PRIORITY_TO_REVIEW' },
  { label: 'Priorité SAP - A', value: 'SAP_A' },
  { label: 'Priorité SAP - B', value: 'SAP_B' },
  { label: 'Priorité SAP - C', value: 'SAP_C' },
  { label: 'Priorité proposée - A', value: 'PROPOSED_A' },
  { label: 'Priorité proposée - B', value: 'PROPOSED_B' },
  { label: 'Priorité proposée - C', value: 'PROPOSED_C' },
  { label: 'Priorité ascendante', value: 'ASCENDING_PRIORITY' },
  { label: 'Priorité descendante', value: 'DESCENDING_PRIORITY' },
  { label: 'Avec priorité sélectionnée', value: 'WITH_SELECTED_PRIORITY' },
  { label: 'Sans priorité sélectionnée', value: 'WITHOUT_SELECTED_PRIORITY' },
];

export const workOrderTypeFilterOptions: SelectItem[] = [
  { label: 'Tous', value: null },
  { label: 'PM01', value: 'PM01' },
  { label: 'PM02', value: 'PM02' },
  { label: 'PM03', value: 'PM03' },
  { label: 'Mauvaise catégorie', value: 'WRONG_CATEGORY' },
];

export const defaultOptions: SelectItem[] = [{ label: 'Tous', value: null }];

export const ordersCandidatesFilterOptions: SelectItem[] = [
  { label: 'Tous', value: null },
  { label: 'Avec Ordres Candidats', value: 1 },
  { label: 'Sans Ordres Candidats', value: 2 },
];

export const readyToScheduleFilterOptions: SelectItem[] = [
  { label: 'Tous', value: null },
  { label: 'Prêt à planifier', value: 1 },
  { label: 'Non prêt', value: 0 },
];

export const userStatusOptions: SelectItem[] = [
  { label: 'Tous', value: null },
  { label: 'OPEN', value: 'OPEN' },
  { label: 'DFSC', value: 'DFSC' },
  { label: 'RPWO', value: 'RPWO' },
  { label: 'FNSC', value: 'FNSC' },
];
